<template lang="pug">
section
    h4(style='font-weight: 800; padding-bottom: 6px') {{ $t('mensagens.territorio.titulo') }}

    el-collapse.colapses(v-model='activeCollapses' accordion)
        form-territorio(
            @update='onForm'
            @validate='event => (validate.isForm = event)'
            :cultivo='cultivo'
            :fields='informacao'
        )

        informacao-especial(
            @add='adicionarLayer'
            @remover='removerMap'
            :layers='layersMaps'
            :geometria='geometryDesenho'
            :informacoes='informacoesEspeciais'
            :codigoLyra='informacao.codigoLyra'
        )

        .grid-cols-three
            enlace-persona(
                @update='setEnlace'
                @delete='setDelete'
                :papeis='papeis'
                :representantes='representantes'
                :options='params.representantes'
                :loading='loadingRepresentante'
            )

            upload-arquivos(
                @add='setUpload'
                @delete='setDeleteArquivo'
                :items='params.arquivosTerritorio'
            )

            upload-evidencias(
                v-if='showUploadEvidencias'
                @add='setUploadEvidencia'
                @delete='setDeleteEvidencia'
                @before-delete='handleBeforeDeleteEvidencia'
                @update='setUpdateEvidencia'
                :items='params.evidencias'
            )

    .flex.justify-content-end
        el-button(
            type='primary'
            style='margin-top: 15px'
            :disabled='validateForm'
            @click='handlerAdicionar'
        ) Adicionar

    ModalConsolidacao(
        :show='showModalConsolidarArea'
        @close='closeModal'
        @confirmaConsolidacao='confirmaConsolidacao'
    )
    ModalAvisoValidacaoRenspaAR(
        :show='showModalAvisoValidacaoRenspa'
        @close='closeModalValidacaoRenspa'
        @confirma='confirmaValidacaoRenspa'
    )
    ModalSelecionarLocalidadeOnccaAR(
        :show='mostrarModalSelecionarLocalidadeOnccaAR'
        :dados='dadosLocalidadeOncca'
        @voltar='mostrarModalSelecionarLocalidadeOnccaAR = false'
        @retornarDadosSelecionados='exibirDadosLocalidadeOncca'
        @realizarPesquisaOncca='realizarPesquisaOncca'
    )
    ModalConfirmarRemocaoEvidencia(
        :show='showModalConfirmarRemocaoEvidencia'
        @close='closeModalConfirmarRemocaoEvidencia'
        @confirma='confirmarRemocaoEvidencia'
    )
    div(v-if='dialogListaTerritoriosBaseVegaSelect')
        ModalSelecionarTerritoriosBaseVegaSobrepostosAR(
            :show='dialogListaTerritoriosBaseVegaSelect'
            :territoriosBaseVega='territoriosBaseVegaComInterseccao'
            :geometriaTerritorio='layersMaps.length > 0 ? layersMaps[0].geometry : {}'
            :is-edit='false'
            @voltar='dialogListaTerritoriosBaseVegaSelect = false'
            @salvar='salvarTerritorioBaseVegaEscolhido'
        )
</template>

<script>
import CulturaService from '@/services/CulturaService';
import representanteService from '@/services/RepresentanteService';
import territorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters } from 'vuex';

import FormTerritorio from './componentes/form-territorio/index.vue';
import InformacaoEspecial from './componentes/informacao-especial/index.vue';
import EnlacePersona from './componentes/enlace-persona/index.vue';
import UploadArquivos from './componentes/upload-arquivos/index.vue';
import UploadEvidencias from './componentes/upload-evidencias/index.vue';

import ModalConsolidacao from '@/components/territorio/ModalConsolidacaoAR.vue';
import ModalAvisoValidacaoRenspaAR from '@/components/territorio/ModalAvisoValidacaoRenspaAR.vue';
import ModalSelecionarLocalidadeOnccaAR from '@/components/territorio/ModalSelecionarLocalidadeOnccaAR.vue';
import ModalConfirmarRemocaoEvidencia from '@/components/territorio/ModalConfirmarRemocaoEvidencia.vue';
import ModalSelecionarTerritoriosBaseVegaSobrepostosAR from '@/components/territorio/ModalSelecionarTerritoriosBaseVegaSobrepostosAR.vue';

const estadoInicial = () => ({
    informacao: {
        nome: null,
        provincia: null,
        renspa: null,
        informacoesAgricolas: [],
        idInterno: null,
        verificadoAr: null,
        codigoOncca: null,
        codigoLyra: null
    },
    params: {
        representantes: [],
        arquivosTerritorio: [],
        evidencias: []
    },
    layersMaps: [],
    geometryDesenho: {},
    geometriaRenspaJaExistente: {},
    idLocalidadeOnccaRenspaJaExistente: null,
    selecionadoOnccaManualmenteRenspaJaExistente: null,
    informacoesEspeciais: {},
    usarGeometriaRenspaJaExistente: false,
    dadosOnccaSelecionado: {},
    idVegaAr: null,
    geometriaRemanescente: null
});

export default {
    name: 'CadastroManual',
    components: {
        FormTerritorio,
        InformacaoEspecial,
        EnlacePersona,
        UploadArquivos,
        UploadEvidencias,
        ModalConsolidacao,
        ModalAvisoValidacaoRenspaAR,
        ModalSelecionarLocalidadeOnccaAR,
        ModalConfirmarRemocaoEvidencia,
        ModalSelecionarTerritoriosBaseVegaSobrepostosAR
    },

    props: {
        territoriosJaAdicionados: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            ...estadoInicial(),
            activeCollapses: [],
            cultivo: [],
            papeis: [],
            representantes: [],
            validate: {
                isForm: false
            },
            showModalConsolidarArea: false,
            showModalAvisoValidacaoRenspa: false,
            mostrarModalSelecionarLocalidadeOnccaAR: false,
            dadosLocalidadeOncca: [],
            showModalConfirmarRemocaoEvidencia: false,
            indexEvidenciaParaRemover: null,
            dialogListaTerritoriosBaseVegaSelect: false,
            territoriosBaseVegaComInterseccao: [],
            loadingRepresentante: false
        };
    },

    created() {
        this.getCultura();
        this.getPapeis();
        this.getRepresentante();
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        validateForm() {
            return !(
                this.validate.isForm &&
                this.params.representantes.length > 0 &&
                this.layersMaps.length > 0
            );
        },
        showUploadEvidencias() {
            return this.usuarioLogado.isArgentinaRevenda;
        }
    },

    methods: {
        onForm(value) {
            this.informacao = { ...value };
        },

        removerMap(index) {
            this.layersMaps.splice(index, 1);
        },

        async adicionarLayer(layer) {
            const indice = this.layersMaps.length;
            this.layersMaps.push(layer);

            await this.esperarGeometry(indice);

            this.postGeometria(this.layersMaps[indice].geometry, indice);
        },

        async postGeometria(geometria, index) {
            try {
                const { data } = await LocalidadeService.buscarLocalidadesPorGeometria(geometria);
                this.layersMaps[index].distrito = data.distritoNome;
                this.layersMaps[index].departamento = data.departamentoNome;
                this.geometryDesenho = geometria;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        esperarGeometry(index) {
            return new Promise(resolve => {
                const checar = () => {
                    if (this.layersMaps[index]?.geometry) resolve();
                    else setTimeout(checar, 100);
                };
                checar();
            });
        },

        setEnlace(value) {
            this.params.representantes.push(value);
        },

        setDelete(index) {
            this.params.representantes.splice(index, 1);
        },

        setUpload(value) {
            this.params.arquivosTerritorio.push(value);
        },

        setDeleteArquivo(index) {
            this.params.arquivosTerritorio.splice(index, 1);
        },

        setUploadEvidencia(value) {
            this.params.evidencias.push(value);
        },

        setDeleteEvidencia(index) {
            this.params.evidencias.splice(index, 1);
        },

        handleBeforeDeleteEvidencia({ index, item }) {
            if (item?.urlDownload) {
                this.indexEvidenciaParaRemover = index;
                this.showModalConfirmarRemocaoEvidencia = true;
            } else {
                this.setDeleteEvidencia(index);
            }
        },

        closeModalConfirmarRemocaoEvidencia() {
            this.showModalConfirmarRemocaoEvidencia = false;
            this.indexEvidenciaParaRemover = null;
        },

        confirmarRemocaoEvidencia() {
            if (this.indexEvidenciaParaRemover !== null) {
                this.setDeleteEvidencia(this.indexEvidenciaParaRemover);
                this.closeModalConfirmarRemocaoEvidencia();
            }
        },

        setUpdateEvidencia({ index, arquivo }) {
            this.$set(this.params.evidencias, index, arquivo);
        },

        async getCultura() {
            const { data } = await CulturaService.buscarCultura();
            this.cultivo = data;
        },

        async getPapeis() {
            const { data } = await territorioService.listaPapeis();
            this.papeis = data;
        },

        async getRepresentante() {
            this.loadingRepresentante = true;
            try {
                const { data } = await representanteService.listarRepresentante();
                this.representantes = data;
            } catch (error) {
                throw new Error({ cause: error });
            } finally {
                this.loadingRepresentante = false;
            }
        },

        async handlerAdicionar() {
            if (this.layersMaps.length > 1) {
                this.showModalConsolidarArea = true;
                return;
            }

            const renspa = this.informacao.renspa?.replace(/[^\d]+/g, '') ?? '';
            if (renspa) {
                const valido = await this.validacaoTerritorioRenspa(renspa);

                if (!valido) {
                    this.showModalAvisoValidacaoRenspa = true;
                    return;
                }
            }
            if (this.dadosOnccaSelecionado?.id) {
                await this.validaSobreposicaoBaseVegaAR();
            } else {
                this.buscaLocalidadeOnccaPorGeometria();
            }
        },

        async validacaoTerritorioRenspa(codigoRenspa) {
            const { data } = await territorioService.validacaoTerritorioRenspa(codigoRenspa, 0);

            if (data?.renspaUtilizado) {
                this.geometriaRenspaJaExistente = data.geometria;
                this.idLocalidadeOnccaRenspaJaExistente = data.localidadeOncca.id;
                this.selecionadoOnccaManualmenteRenspaJaExistente = data.localidadeOncca.inseridoManual;
                return false;
            }
            return true;
        },

        async buscaLocalidadeOnccaPorGeometria() {
            const geometria = this.usarGeometriaRenspaJaExistente
                ? this.geometriaRenspaJaExistente
                : this.layersMaps[0].geometry;

            try {
                const { data } = await LocalidadeService.buscarLocalidadeOncca({ geoJson: geometria });

                this.dadosLocalidadeOncca = data.itens;
                this.mostrarModalSelecionarLocalidadeOnccaAR = true;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        async realizarPesquisaOncca(filtro) {
            const { data } = await LocalidadeService.buscarLocalidadeOncca({ textoBusca: filtro });
            this.dadosLocalidadeOncca = data.itens;
        },

        async exibirDadosLocalidadeOncca(dadosLocalidadeOnccaSelecionado) {
            this.dadosOnccaSelecionado = dadosLocalidadeOnccaSelecionado;
            if (this.dadosOnccaSelecionado) {
                await this.validaSobreposicaoBaseVegaAR();
            }
        },

        async validaSobreposicaoBaseVegaAR() {
            try {
                const geometria = this.usarGeometriaRenspaJaExistente
                    ? this.geometriaRenspaJaExistente
                    : this.layersMaps[0].geometry;

                const response = await territorioService.validaSobreposicaoBaseVegaAR(geometria);
                const { data } = response;

                this.geometriaRemanescente = data.geometriaRemanescente || null;

                if (!data?.possuiSobreposicao) {
                    this.emitirTerritorio();
                    return;
                }

                this.territoriosBaseVegaComInterseccao = data.itens;
                this.dialogListaTerritoriosBaseVegaSelect = true;
            } catch (error) {
                this.$notify.error({
                    message: error?.response?.data?.message || error.message
                });
            }
        },

        salvarTerritorioBaseVegaEscolhido(territorioBaseVegaSelecionado) {
            this.idVegaAr = territorioBaseVegaSelecionado.idVega;
            this.dialogListaTerritoriosBaseVegaSelect = false;

            this.layersMaps = [];
            this.layersMaps.push({
                type: 'AREA_CONSOLIDADA',
                codigo: 'AREA_CONSOLIDADA',
                area_ha: territorioBaseVegaSelecionado.areaHa || territorioBaseVegaSelecionado.territorioArea,
                geometry: territorioBaseVegaSelecionado.geometria,
                geoJson: territorioBaseVegaSelecionado.geometria,
                identificadorGeometria: territorioBaseVegaSelecionado.cdTerritorio,
                departamento: '',
                distrito: ''
            });

            this.emitirTerritorio();
        },

        confirmaConsolidacao() {
            const listGeometryToSend = {
                geometries: this.layersMaps.map(item => ({ ...item.geometry }))
            };

            territorioService.consolidaTerritorio(listGeometryToSend).then(response => {
                if (response.status === 200) {
                    this.layersMaps = [{
                        identificadorGeometria: new Date().getTime(),
                        type: response.data.tipo,
                        codigo: 'AREA_CONSOLIDADA',
                        area_ha: response.data.areaTotal,
                        geometry: response.data.geometry,
                        geoJson: response.data.geometry,
                        departamento: '',
                        distrito: ''
                    }];

                    this.showModalConsolidarArea = false;
                    this.handlerAdicionar();

                } else {
                    this.$notify.error({ message: this.$t('mensagens.territorio.erroAoConsolidarTerritorios') });
                }
            });
        },

        confirmaValidacaoRenspa() {
            this.usarGeometriaRenspaJaExistente = true;
            this.buscaLocalidadeOnccaPorGeometria();
        },

        closeModal() { this.showModalConsolidarArea = false; },

        closeModalValidacaoRenspa() { this.showModalAvisoValidacaoRenspa = false; },

        emitirTerritorio() {
            const { idInterno, ...informacao } = this.informacao;

            const territorio = {
                ...informacao,
                ...this.params,
                id_interno: idInterno || null,
                renspa: this.informacao.renspa?.replace(/[^\d]+/g, '') ?? null,
                geoJson: this.usarGeometriaRenspaJaExistente
                    ? this.geometriaRenspaJaExistente
                    : this.layersMaps[0].geometry,
                representantes: this.params.representantes.map(item => ({
                    idPapel: item.papel.id,
                    id: item.pessoa.id,
                    nomeRazaoSocial: item.pessoa.nome,
                    papel: item.papel.nome
                })),
                informacoesAgricolas: this.informacao.informacoesAgricolas.map(item => ({
                    areaPlantada: item.area,
                    produtividade: item.media,
                    idCultura: item.idCultura,
                    nome: item.nome
                })),
                idLocalidadeOncca: this.usarGeometriaRenspaJaExistente
                    ? this.idLocalidadeOnccaRenspaJaExistente
                    : this.dadosOnccaSelecionado.id,
                selecionadoOnccaManualmente: this.usarGeometriaRenspaJaExistente
                    ? this.selecionadoOnccaManualmenteRenspaJaExistente
                    : this.dadosOnccaSelecionado.inseridoManual,
                idVegaAr: this.idVegaAr,
                geometriaRemanescente: this.geometriaRemanescente
                    ? JSON.stringify(this.geometriaRemanescente)
                    : null,
                totalAreaHa: this.formatAreaHa(this.layersMaps[0]?.area_ha),
                origem: 'Manual'
            };

            this.$emit('adicionar', territorio);
            this.resetar();
        },

        formatAreaHa(value) {
            const clean = String(value ?? '0')
                .replace(/\./g, '')
                .replace(',', '.');

            const number = parseFloat(parseFloat(clean).toFixed(3)) || 0;

            return number.toLocaleString('pt-BR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
            }) + ' ha';
        },

        resetar() {
            Object.assign(this.$data, {
                ...estadoInicial(),
                activeCollapses: [],
                cultivo: this.cultivo,
                papeis: this.papeis,
                representantes: this.representantes,
                showModalConsolidarArea: false,
                showModalAvisoValidacaoRenspa: false,
                mostrarModalSelecionarLocalidadeOnccaAR: false,
                dadosLocalidadeOncca: [],
                showModalConfirmarRemocaoEvidencia: false,
                dialogListaTerritoriosBaseVegaSelect: false,
                territoriosBaseVegaComInterseccao: []
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.el-collapse {
    border: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.grid-cols-three {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
}

@media (max-width: 1400px) {
    .grid-cols-three {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
}
</style>
